export enum DialogType {
  INFORMATION = 'info',
  ERROR = 'error',
  CONFIRM = 'confirm',
  NONE = 'none',
}
